export const SIZE_ATTENUATION_FACTOR = '600.0';
